import { Box, Checkbox, FormControlLabel, Tooltip } from "@mui/material";
import { Dispatch } from "react";
import { useTranslation } from "react-i18next";
import { useAllergensQuery } from "../../../types";
import { AllergenPicker } from "../../Allergen/AllergenPicker";
import { canSelectAllergenFree, effectiveAllergens } from "./allergens";
import { RecipeFormAction, RecipeFormState } from "./utils";

interface RecipeFormAllergensProps {
  state: RecipeFormState;
  dispatch: Dispatch<RecipeFormAction>;
  disabled?: boolean;
}

export const RecipeFormAllergens = ({ state, dispatch, disabled }: RecipeFormAllergensProps) => {
  const { t } = useTranslation();
  const { data } = useAllergensQuery();

  const allergenFreeAvailable = canSelectAllergenFree(state);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <AllergenPicker
        options={data?.allergens ?? []}
        value={effectiveAllergens(state)}
        readOnlyValue={state.inheritedAllergens}
        disabled={disabled}
        onChange={keys =>
          dispatch({
            type: "CHANGE_SELF_ALLERGENS",
            value: keys.filter(key => !state.inheritedAllergens.includes(key)),
          })
        }
      />
      <Tooltip title={allergenFreeAvailable ? "" : t("allergenFree.unavailableTooltip")}>
        <Box component="span" sx={{ alignSelf: "flex-start" }}>
          <FormControlLabel
            label={t("allergenFree.label")}
            control={
              <Checkbox
                checked={state.allergenFree && allergenFreeAvailable}
                disabled={disabled || !allergenFreeAvailable}
                onChange={event => dispatch({ type: "CHANGE_ALLERGEN_FREE", value: event.target.checked })}
              />
            }
          />
        </Box>
      </Tooltip>
    </Box>
  );
};
